// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AM5Aa31kPnJEJkmwEUYb{display:flex;flex-direction:column;gap:12px}.AM5Aa31kPnJEJkmwEUYb .G2RZOIo9WkFFJ9sndgdj{border-color:var(--content-negative-primary)}`, "",{"version":3,"sources":["webpack://./src/entities/CustomField/ui/CustomFieldModal/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAEA,4CACE,4CAAA","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  .selectError {\n    border-color: var(--content-negative-primary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AM5Aa31kPnJEJkmwEUYb`,
	"selectError": `G2RZOIo9WkFFJ9sndgdj`
};
export default ___CSS_LOADER_EXPORT___;
